import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Dashboard from '../Screens/Admin/Dashboard'
import AdminLayout from '../Component/Layout/AdminLayout'
import Clients from '../Screens/Admin/Clients/Clients'
import ClientDashboard from '../Screens/Client/Dashboard'
import ClientLayout from '../Component/Layout/ClientLayout'
import Dealers from '../Screens/Client/Dealers/Dealers'
import AuthLayout from '../Component/Layout/AuthLayout'
import Login from '../Screens/Auth/Login'
import { useSelector } from 'react-redux'
import { RootState } from '../Redux/store'
import AddNewClient from '../Screens/Admin/Clients/AddNewClient'
import CreateDealer from '../Screens/Client/Dealers/CreateDealer'
import Productlist from '../Screens/Client/Products/Productlist'
import AddorUpdateProduct from '../Screens/Client/Products/AddorUpdateProduct/AddorUpdateProduct'
import AllOrders from '../Screens/Client/Orders/AllOrders'
import PendingApprovals from '../Screens/Client/Orders/PendingApprovals'
import OrderDetails from '../Screens/Client/Orders/OrderDetails'
import DealerDashboard from '../Screens/Dealer/Dashboard'
import DealerProducts from '../Screens/Dealer/DealerProducts'
import DealerProductDetails from '../Screens/Dealer/DealerProductDetails'
import Cartlist from '../Screens/Dealer/Cart/Cartlist'
import NotFound from '../Component/NotFound/NotFound'
import InvoiceList from '../Screens/Dealer/Invoice/InvoiceList'
import ForgotPassword from '../Screens/Auth/ForgotPassword'
import VerifyOtp from '../Screens/Auth/VerifyOtp'
import ResetPassword from '../Screens/Auth/ResetPassword'

function AppRoutes() {
  const { userDetails } = useSelector((state: RootState) => state.global)
  console.log("User Details", userDetails)
  return (
    <Routes>

      <Route path="/" element={
        <AuthLayout>
          <Login />
        </AuthLayout>
      } />
      <Route path="/login" element={
        <AuthLayout>
          <Login />
        </AuthLayout>
      } />

      <Route path="/forgot-password" element={ <AuthLayout>
        <ForgotPassword /> 
        </AuthLayout>
        } 
        />
      <Route path="/verify-otp" element={ <AuthLayout><VerifyOtp /> </AuthLayout>} />
      <Route path="/reset-password" element={<AuthLayout><ResetPassword /></AuthLayout>} />


      <Route path="/admin/dashboard" element={
        <AdminLayout>
          <Dashboard />
        </AdminLayout>
      } />
      <Route path="/admin/clients" element={
        <AdminLayout>
          <Clients />
        </AdminLayout>
      } />
      <Route path="/admin/add-or-update-client" element={
        <AdminLayout>
          <AddNewClient />
        </AdminLayout>
      } />
      <Route
        path="/admin/add-or-update-client/:clientId"
        element={
          <AdminLayout>
            <AddNewClient />
          </AdminLayout>
        }
      />
      <Route path="/admin/products" element={
        <AdminLayout>
          <Productlist />
        </AdminLayout>
      } />
      <Route path="/admin/order-details/:orderId" element={
        <AdminLayout>
          <OrderDetails />
        </AdminLayout>
      } />




      <Route path="/client/dashboard" element={
        <ClientLayout>
          <ClientDashboard />
        </ClientLayout>
      } />

      <Route path="/client/dealers" element={
        <ClientLayout>
          <Dealers />
        </ClientLayout>
      } />
      <Route path="/client/add-or-update-dealer" element={
        <ClientLayout>
          <CreateDealer />
        </ClientLayout>
      } />
      <Route path="/client/add-or-update-dealer/:subClientId" element={
        <ClientLayout>
          <CreateDealer />
        </ClientLayout>
      } />

      <Route path="/client/products" element={
        <ClientLayout>
          <Productlist />
        </ClientLayout>
      } />

      <Route path="/client/products/add-or-update-product" element={
        <ClientLayout>
          <AddorUpdateProduct />
        </ClientLayout>
      } />
      <Route path="/client/products/add-or-update-product/:productId" element={
        <ClientLayout>
          <AddorUpdateProduct />
        </ClientLayout>
      } />
      <Route path="/client/all-orders" element={
        <ClientLayout>
          <AllOrders />
        </ClientLayout>
      } />
      <Route path="/client/pending-approvals" element={
        <ClientLayout>
          <PendingApprovals />
        </ClientLayout>
      } />
      <Route path="/client/order-details/:orderId" element={
        <ClientLayout>
          <OrderDetails />
        </ClientLayout>
      } />
      <Route path="/client/invoice" element={
        <ClientLayout>
          <InvoiceList />
        </ClientLayout>
      } />




      <Route path="/subclient/dashboard" element={
        <ClientLayout>
          <DealerDashboard />
        </ClientLayout>
      } />
      <Route path="/subclient/products" element={
        <ClientLayout>
          <DealerProducts />
        </ClientLayout>
      } />
      <Route path="/subclient/products/product-details/:productId" element={
        <ClientLayout>
          <DealerProductDetails />
        </ClientLayout>
      } />
      <Route path="/subclient/cart/cartlist" element={
        <ClientLayout>
          <Cartlist />
        </ClientLayout>
      } />
      <Route path="/subclient/invoice" element={
        <ClientLayout>
          <InvoiceList />
        </ClientLayout>
      } />



      <Route path="*" element={<Navigate to="/404" replace />} />

      <Route path="/404" element={<NotFound />} />

    </Routes>
  )
}

export default AppRoutes
